module.exports = __webpack_public_path__ + "img/trial4-4.b0760a73.png";